module.exports = __webpack_public_path__ + "img/1.76eb9a61.png";